import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery } from '@picsart/rc/helpers';
import { createUseStyles } from 'react-jss';

import type { AspectRatioBreakPoints, AspectRatioMaxHeight } from './types';

const useStyles = createUseStyles(
  () => ({
    root: {
      width: '100%',
      maxHeight: (props: {
        maxHeight?: AspectRatioMaxHeight;
        dimension?: AspectRatioBreakPoints;
      }) => props.maxHeight?.xl,
      position: 'relative',
      overflow: 'hidden',

      [mediaQuery(1365)]: {
        maxHeight: props => props.maxHeight?.lg,
      },
      [mediaQuery(1023)]: {
        maxHeight: props => props.maxHeight?.md,
      },
      // [mediaQuery(767)]: {
      // '@media screen and (max-width: 767px)': {
      //   maxHeight: props => props.maxHeight?.sm,
      // },

      display: 'block',
      paddingTop: props => props.dimension.xl,

      [mediaQuery(1365)]: {
        paddingTop: props => props.dimension.lg,
      },
      [mediaQuery(1023)]: {
        paddingTop: props => props.dimension.md,
      },
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        paddingTop: props => props.dimension.sm,
      },
    },
    content: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: Spacings.s0,
      right: Spacings.s0,
      bottom: Spacings.s0,
      left: Spacings.s0,
    },
  }),
  {
    name: 'aspect-ratio',
  },
);

export default useStyles;
